import * as yup from 'yup';
import {
  fileExtension, setLocale,
} from '../../../../utils/yup-utils';

setLocale();

const validationRules = {
  title: yup.string().nullable().required(),
  body: yup.string().nullable().required(),
  type: yup.string().nullable().required(),
  company: yup.mixed().when('all_group', { is: '2', then: yup.string().nullable().required() }).when('type', { is: '3', then: yup.string().nullable().required() }),
  provider: yup.mixed().when('type', { is: '3', then: yup.string().nullable().required() }),
  discount: yup.mixed().when('type', { is: '3', then: yup.string().nullable().required() }),
  delivery_date: yup.mixed().when('scheduled', { is: true, then: yup.date().nullable().required() }),
  delivery_hour: yup.mixed().when('scheduled', { is: true, then: yup.mixed().nullable().required() }),
  file: yup.mixed().test(fileExtension(['xlsx'])).when('type', { is: 1, then: yup.mixed().required() }),
};

const validate = async (form) => {
  const schema = await yup.object().shape(validationRules, ['available_from', 'available_to']);

  try {
    const data = await schema.validate(form, { abortEarly: false });
    return { isValid: true, data, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner) {
      err.inner.forEach((error) => { errors[error.path] = error.message; });
    }
    return { isValid: false, data: form, errors };
  }
}

export default validate;
